import {append as svgAppend, attr as svgAttr} from 'tiny-svg';

import BpmnRenderer from 'bpmn-js/lib/draw/BpmnRenderer';
import {createLine} from 'diagram-js/lib/util/RenderUtil';
import {Base, Connection, Shape} from 'diagram-js/lib/model';
import {exclusiveGatewayType, subProcessType, taskType} from '@ispm-shared/modules/bpmn';
import Styles from 'diagram-js/lib/draw/Styles';
import PathMap from 'bpmn-js/lib/draw/PathMap';
import TextRenderer from 'bpmn-js/lib/draw/TextRenderer';
import Canvas from 'diagram-js/lib/core/Canvas';
import EventBus from 'diagram-js/lib/core/EventBus';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {isEmpty} from 'lodash'

const DEFAULT_RENDER_PRIORITY = 1001;

export class CustomRenderer extends BpmnRenderer {
  handlers: any[];

  constructor(protected config: any, protected eventBus: EventBus, protected styles: Styles, protected pathMap: PathMap, protected canvas: Canvas,
              protected textRenderer: TextRenderer, priority = DEFAULT_RENDER_PRIORITY) {
    super(config, eventBus, styles, pathMap, canvas, textRenderer, priority);
    this.handlers['SubProcessMarker'] = () => {
    };
  }

  private adjustTaskPosition(element): Shape {
    if (element.businessObject.extensionElements && !isEmpty(element.businessObject.extensionElements.values) &&
        element.businessObject.extensionElements.values[0].nodePosition) {
      const coord = element.businessObject.extensionElements.values[0].nodePosition;
      if (element.x !== coord.x) {
        element.x = coord.x;
        let waypoint = !isEmpty(element.incoming) && element.incoming[0].waypoints && element.incoming[0].waypoints[element.incoming[0].waypoints.length - 1];
        if (waypoint) {
          waypoint.x = coord.x;
        }
      }
      if (element.y !== coord.y) {
        element.y = coord.y;
      }

      delete element.businessObject.extensionElements.values[0].nodePosition
    }

    return element;
  }

  drawShape(visuals: SVGElement, el: Shape): SVGElement {
    const element: Shape = el.type === taskType && ModelingUtil.getNodeType(el) === NodeType.normal ? this.adjustTaskPosition(el) : el;

    const shape = super.drawShape(visuals, element);
    if (is(element, subProcessType) || is(element, taskType)) {
      shape.setAttribute('rx', 2);
      shape.setAttribute('ry', 2);
      svgAttr(shape, 'fill-opacity', '1');
    }
    if (is(element, exclusiveGatewayType)) {
        visuals.removeChild(visuals.childNodes[1]); // remove X from gateway
        shape.setAttribute('points', '9,0 18,9 9,18 0,9');
        svgAttr(shape, 'stroke', '#787878');
        svgAttr(shape, 'strokeWidth', '1.5px');
        svgAttr(shape, 'stroke-opacity', '0.8');
    }

    const nodeDetails = ModelingUtil.getNodeDetails(element);
    if (nodeDetails) {
      if (nodeDetails.nodeType !== undefined) {
        visuals.setAttribute('nodeType', NodeType[nodeDetails.nodeType]);
      }
      if (nodeDetails.nodeType === NodeType.treatment) {
        svgAttr(shape, 'fill', '#daf1f7');
        svgAttr(shape, 'strokeWidth', '2px');
        svgAttr(shape, 'width', '360px');
        shape.setAttribute('class', 'treatment');
      }
      if (nodeDetails.hasPrimaryTreatment) {
        const foundElement = visuals.getElementsByTagName('text').length > 0 ? visuals.getElementsByTagName('text').item(0) : undefined;
        if (foundElement) {
          foundElement.setAttribute('class', 'primary-treatment');
          foundElement.setAttribute('style', 'fill:#1474a4');
        }
      }
    }
    return shape;
  }

  drawConnection(p: SVGElement, element: Connection): SVGElement {
      if(element.order) {
        element.order.level = 3;
      }
      const attrs = this.styles.computeStyle(null, {
        stroke: '#979797',
        strokeWidth: 1,
        'stroke-opacity': 0.8,
        'fill-opacity': 0.0
      });
    const filteredPoints = element.waypoints.filter(point => !isNaN(point.x) && !isNaN(point.y));
    return svgAppend(p, createLine(filteredPoints, attrs)) as SVGElement;
  }

  canRender(element: Base): boolean {
    const superResult = super.canRender(element);
    if (!superResult) {
      return false;
    } else {
      if (element.businessObject.markedToBeRendered === false) {
        return false;
      }
      if(ModelingUtil.isBpmnDefaultElement(element)){
        return false;
      }
    }
    return true;
  }

}

